import { useIntl } from 'react-intl';
import { useExternalHref } from 'src/hooks/useExternalHref';
import { Icon } from 'src/components';
import { msgs } from './messages';
import * as S from './styles';

type LogoLinkProps = {
  className?: string;
};

export const LogoLink = ({ className }: LogoLinkProps) => {
  const intl = useIntl();

  const mainPageHref = useExternalHref({ linkType: 'memrise-main-page' });

  return (
    <S.Link
      aria-label={intl.formatMessage(msgs.ariaLabel)}
      className={className}
      data-testid="logoLink"
      href={mainPageHref}
    >
      <Icon name="memrise" />
    </S.Link>
  );
};
